/** @file Screen angle of a screen vector: degrees from screen-down, counter-clockwise as seen. */
import { radToDeg } from '@zilo/pose3d-math/angle/radToDeg';
import { wrapDegrees } from '@zilo/pose3d-std/math/wrapDegrees';

/** `wrap(atan2(vx, vy))` in degrees: 0 down, 90 right, 180 up, 270 left (y down). */
export function screenAngle(vx: number, vy: number): number {
  return wrapDegrees(radToDeg(Math.atan2(vx, vy)));
}
